import { getTitleGroups, getBdAtpFeeds, getBdAdvertiserExts } from '@/api/open'
import { storeOrUpdateAdTask } from '@/api/ad-task-baidu'
import moment from 'moment'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import CodeInput from '@/components/code-input/CodeInput.vue'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import VideoSelect from '@/views/sys/baidu/video-select/VideoSelect.vue'
import { getBdTypes, getBdTransTypes } from '@/api/baiduConstant'
import AtpFeed from '@/components/baidu/atp-feed/AtpFeed.vue'
import { getBdBrands } from '@/api/baiduBrand'

export default {
    components: {
        MaterialSelect,
        VideoSelect,
        CodeInput,
        AdvSelect,
        AtpFeed,
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        showCreateForm: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            postData: [], //最终提交数据
            advs: {},
            subjects: [
                { id: 1, name: '网站链接' },
                { id: 2, name: '应用下载（IOS）' },
                { id: 3, name: '应用下载（Android）' },
                { id: 4, name: '小程序' },
                { id: 7, name: '电商店铺' },
                { id: 8, name: '销售线索' },
            ],
            price_types: [
                { id: 1, name: '计划出价' },
                { id: 2, name: '常规出价' },
            ],
            campaignTypes: [
                { id: 1, name: '普通模式' },
                { id: 4, name: '放量模式' },
            ],
            budget_models: [
                { id: 1, name: '不限' },
                { id: 2, name: '自定义' },
            ],
            tgdate_models: [
                { id: 1, name: '不限' },
                { id: 2, name: '自定义' },
            ],
            zt_models: [
                { id: 1, name: '不限' },
                { id: 2, name: '自定义' },
            ],
            group_ftype_models: [
                { id: 2, name: '使用计划流量设置' },
                { id: 1, name: '为单元单独设置' },
            ],
            ftype_models: [
                { id: 1, name: '默认' },
                { id: 2, name: '百青藤' },
                { id: 3, name: '自定义' },
            ],
            bdPages: [],
            atpId: null,
            apt_feed_data: {}, //定向包内容apt_feed_data
            atpFeeds: [], //百度定向包
            showDXB: false, //是否展示定向包
            bidSources: [
                { id: 2, name: '使用计划出价' },
                { id: 1, name: '为本单元单独设置' },
            ], //单元出价
            bidtypes: [
                { id: 3, name: '转化 oCPC' },
                { id: 1, name: '点击 CPC' },
                { id: 2, name: '曝光 CPM' },
            ],
            trans_types: [],
            transTypesForm: [],
            price_models: [
                { id: 1, name: '固定出价' },
                { id: 2, name: '阶梯出价' },
                { id: 3, name: '随机出价' },
            ],
            allocation_types: [
                { id: 1, name: '随机分配' },
                { id: 2, name: '自定义' },
            ],
            ideaTypes: [
                { id: 1, name: '程序化' },
                { id: 0, name: '自定义' },
            ],
            materials: [],

            model: {
                ids: [],
                name: '',
                //计划
                campaignFeedName: '',
                subject: 1,
                price_type: 2,
                pause: true,
                campaignType: 1,
                budget_model: 1,
                budget: 50,
                tgdate_model: 1,
                tg_date: [moment(), moment().add(3, 'months')],
                zt_model: 1,
                schedule: [],
                //单元
                adgroupFeedName: '',
                adgroupFeedPause: true,
                group_ftypes_model: 1,
                ftypes_model: 1,
                ftypesSelect: [],
                bidSource: 1,
                bidtype_model: 3,
                price_model: 1,
                ocpc_bid: 0.3,
                ocpc_bid_min: null,
                ocpc_bid_max: null,
                //创意
                allocation_type: 1, //分配策略
                ideaType: 1, //创意方式

                // campaign_feed_num: null, //计划数
                // adgroup_feed_num: null, //单元数
                // video_num: null, //视频数

                //TODO 调试
                // campaign_feed_num: 35, //计划数
                // adgroup_feed_num: 2, //单元数
                // video_num: 2, //视频数

                picture_num: 0,
                three_picture_num: 0,
                titles: [],
                brand: null,
                brand_cover: null,
            },

            sellingPoints: [],
            awemes: [],
            corporations: [],
            loading: false,
            syncLoading: false,
            actionName: '操作',
            timeout: null,
            rules: {
                'ids': [{ required: true, message: '请选择广告主', trigger: 'change' }],
                'name': [{ required: true, message: '请输入任务名称', trigger: 'change' }],
                'campaignFeedName': [{ required: true, message: '请输入计划名称', trigger: 'change' }],
                'budget': [
                    { required: true, message: '请输入预算', trigger: 'change' },
                    { type: 'number', min: 50, message: '最小输入数字为50', trigger: 'change' }
                ],
                'adgroupFeedName': [{ required: true, message: '请输入单元名称', trigger: 'change' }],
                'ftypesSelect': [{ required: true, message: '请选择流量范围', trigger: 'change' }],
                'ocpc_bid': [{ required: true, message: '请输入目标转化出价', trigger: 'change' }],
                'ocpc_bid_min': [{ required: true, message: '请输入目标转化最低出价', trigger: 'change' }, { validator: (rule, value, callback) => this.validateNumber(rule, value, callback, 0.3), message: '目标转化最低出价是0.3', trigger: 'blur' }],
                'ocpc_bid_max': [{ required: true, message: '请输入目标转化最高出价', trigger: 'change' }, { validator: (rule, value, callback) => this.validateNumber(rule, value, callback, 0.3), message: '目标转化最低出价是0.3', trigger: 'blur' }],
                'campaign_feed_num': [{ required: true, message: '请输入计划数', trigger: 'change' }, { validator: (rule, value, callback) => this.validateNumber(rule, value, callback, 1), trigger: 'blur' }],
                'adgroup_feed_num': [{ required: true, message: '请输入单元数', trigger: 'change' }, { validator: (rule, value, callback) => this.validateNumber(rule, value, callback, 1), trigger: 'blur' }],
                'video_num': [{ required: true, message: '请输入视频数', trigger: 'change' }, { validator: (rule, value, callback) => this.validateNumber(rule, value, callback, 1), trigger: 'blur' }],
                'titles': [{ required: true, message: '请输入标题', trigger: 'change' }],
                'brand': [{ required: true, message: '请选择品牌信息', trigger: 'change' }],

            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            currentAdvId: null,
            current: 0,
            steps: [
                { title: '推广计划' },
                { title: '推广单元' },
                { title: '转化/落地页' },
                { title: '推广创意' },
                { title: '素材分配' },
                { title: '任务结果' },
            ],
            titleGroups: [],
            brands: [],
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '新建'
        },
    },
    mounted() {
        if (this.params.params) {
            this.model = Object.assign({}, this.$helper.deepClone(this.params.params.origin_data.model))
            this.advs = Object.assign({}, this.$helper.deepClone(this.params.params.origin_data.advs))
            this.$set(this.model, 'ids', this.params.advertiser_ids)
            if (this.params.params.origin_data.materials && this.params.params.origin_data.materials.length > 0) {
                this.materials = this.params.params.origin_data.materials
            }
            if (this.params.params.origin_data.audience ) {
                this.apt_feed_data = this.params.params.origin_data.audience
            }
            this.init()
        } else if (this.params.ids) {
            this.$set(this.model, 'ids', this.params.ids)
            this.init()
        }

        getBdTransTypes().then(res => {
            this.trans_types = res.data.list || []
            if (this.model.ocpc && this.model.ocpc.transType) {
                this.transTypeName = this.$helper.getItemName(this.trans_types, this.model.ocpc.transType)
            }
        })

        //TODO 调试
        // this.$set(this.model, 'ids', [6365,6366,6367])
        // this.$set(this.model, 'ids', [6365, 6366])
        // this.init()

        getBdTypes().then(res => {
            this.ftypes = res.data.list || []
            this.ftypes = this.ftypes.filter(item => item.id !== 3)
        })
        //百度定向包
        getBdAtpFeeds().then(res => {
            this.atpFeeds = res.data.list || []
        })


        getTitleGroups().then(res => { this.titleGroups = res.data.list || [] })
        getBdBrands().then(res => { this.brands = res.data.list || [] })


        this.model.campaignFeedName = '推广计划_' + moment().format('_MM_DD_HH:mm:ss')
        this.model.adgroupFeedName = '推广单元_' + moment().format('_MM_DD_HH:mm:ss')
        this.model.creativeFeedName = '推广创意_' + moment().format('_MM_DD_HH:mm:ss')
    },
    watch: {
    },
    created() { },
    methods: {
        changeAdvs() {
            this.$nextTick(() => {
                if (this.currentAdvId !== this.model.ids[0]) {
                    //改变获取第一个广告主的相关信息
                    this.materials = []
                }
            })
            this.$nextTick(this.init)
        },
        init() {
            this.currentAdvId = this.model.ids[0]
            if (this.model.ids.length === 0) {
                return false
            }

            this.loading = true
            //获取百度额外信息
            getBdAdvertiserExts({ ids: this.model.ids }).then(res => {
                let advs = res.data.list || []
                // this.advs = res.data.list || []

                //有默认值，赋值默认值
                for (const key in this.advs) {
                    const adv = this.advs[key]
                    if (adv.appTransId) {
                        advs[key].appTransId = adv.appTransId
                    }
                    if (adv.transType) {
                        advs[key].transType = adv.transType
                        this.transTypesForm[adv.appTransId] = [adv.transType]
                    }
                    if (adv.monitorUrl) {
                        advs[key].monitorUrl = adv.monitorUrl
                    }
                    if (adv.url) {
                        advs[key].url = adv.url
                    }
                    if (adv.materials && adv.materials>0) {
                        advs[key].materials = adv.materials
                    }
                }
                this.advs = advs
            }).then(() => {
                this.loading = false
            })
        },
        next() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                if(this.current === 1) {
                    if (this.showDXB === true) {
                        this.$refs.atpFeedRef.getAtpFeedData();
                    }
                }else if (this.current === 2) {
                    // console.log('advs', this.advs)
                    for (const key in this.advs) {
                        const adv = this.advs[key]
                        if (!adv.appTransId || !adv.transType) {
                            return this.$message.error(`请关联广告主[${adv.name}]转化`)
                        }
                        if (!adv.url) {
                            return this.$message.error(`请关联广告主[${adv.name}]落地页`)
                        }
                    }
                } else if (this.current === 3) {
                    // console.log('素材长度',this.materials.length)
                    if (this.materials.length < 1) {
                        return this.$message.error('请选择视频素材')
                    }
                    for (const key in this.advs) {
                        //分配后，开始赋值
                        this.advs[key].materials = this.allocationMaterials()
                    }

                }
                this.current++
            })
        },
        allocationMaterials() {
            let materials = []
            this.model.campaign_feed_num = parseInt(this.model.campaign_feed_num)
            this.model.adgroup_feed_num = parseInt(this.model.adgroup_feed_num)
            this.model.video_num = parseInt(this.model.video_num)

            for (let index1 = 0; index1 < this.model.campaign_feed_num; index1++) {
                materials[index1] = []; // 初始化 campaign_feed_num 维度的数组
                for (let index2 = 0; index2 < this.model.adgroup_feed_num; index2++) {
                    materials[index1][index2] = []; // 初始化 adgroup_feed_num 维度的数组
                    for (let index3 = 0; index3 < this.model.video_num; index3++) {
                        const randomRecords = this.getRandomRecords(this.materials, this.model.video_num);
                        materials[index1][index2] = randomRecords; // 将随机记录添加到数组中
                    }
                }
            }
            return materials
        },
        //数组随机取n条记录
        getRandomRecords(array, n) {
            // 先复制原始数组，以免修改原数组
            const copyArray = array.slice();
            const result = [];
            while (result.length < n && copyArray.length > 0) {
                const randomIndex = Math.floor(Math.random() * copyArray.length);
                const record = copyArray.splice(randomIndex, 1)[0];

                if (!result.includes(record)) {
                    result.push(record);
                }
            }
            return result;
        },
        prev() {
            this.$refs.form.clearValidate()
            this.current--
        },
        submit() {
            this.$message.destroy()

            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                //检查
                for (const key in this.advs) {
                    const adv = this.advs[key]

                    if (!adv.appTransId || !adv.transType) {
                        return this.$message.error(`请关联广告主[${adv.name}]转化`)
                    }
                    if (!adv.url) {
                        return this.$message.error(`请关联广告主[${adv.name}]落地页`)
                    }
                    if (!adv.materials || adv.materials.length < 1) {
                        return this.$message.error(`请广告主[${adv.name}]选择视频素材`)
                    }
                }

                // console.log('处理前的数据：', this.model, this.advs)
                this.makePostData()
                
                this.storeOrUpdate()

            })

        },
        //组装最终数据
        makePostData() {
            let postData = []
            postData['name'] = this.model.name
            postData['campaign_feed_num'] = parseInt(this.model.campaign_feed_num) //计划数
            postData['adgroup_feed_num'] = parseInt(this.model.adgroup_feed_num) //单元数
            postData['ids'] = this.model.ids //广告主
            postData['data'] = {}
            postData['origin_data'] = {
                'model': this.model,
                'advs': this.advs,
                'materials': this.materials,
                'audience': this.apt_feed_data,
            }

            // console.log('postData', postData)
            let schedule = []
            if (this.model.zt_models != 1) {
                this.model.schedule.forEach((element, index) => {
                    element.forEach(item => {
                        if (item % 2 == 0) {
                            schedule.push({
                                "endHour": item / 2 + 1,
                                "startHour": item / 2,
                                "weekDay": index + 1
                            })
                        }
                    });
                });
            }

            for (const key in this.advs) {
                const adv = this.advs[key]
                const advId = adv.id.toString()
                postData['data'][advId] = {}
                //组装计划数据
                postData['data'][advId]['campaignFeed'] = {
                    'campaignFeedName': this.model.campaignFeedName,
                    'pause': this.model.pause ? false : true,
                    'subject': this.model.subject,
                    'price_type': this.model.price_type,
                    'campaignType': this.model.campaignType,
                    'bidtype': this.model.bidtype_model,
                    'budget': this.model.budget_model === 1 ? null : this.model.budget,
                    'starttime': this.model.tgdate_model === 1 ? null : this.model.tg_date[0],
                    'endtime': this.model.tgdate_model === 1 ? null : this.model.tg_date[1],
                    'schedule': schedule,
                }

                //组装单元数据
                let ocpc = {}
                const arr = adv.appTransId.split('|');
                ocpc.appTransId = parseInt(arr[1])
                ocpc.transFrom = parseInt(arr[3])
                ocpc.transType = adv.transType
                ocpc.ocpcBid = this.model.ocpc_bid
              
                postData['data'][advId]['adgroupFeed'] = {
                    'adgroupFeedName': this.model.adgroupFeedName,
                    'bidtype': this.model.ftypes_model,
                    'pause': this.model.adgroupFeedPause ? false : true,
                    'ftypeSelection': this.model.group_ftypes_model === 1 ? 1 : 2,
                    'ftypes': this.model.ftypes_model === 1 ? [] : (this.model.ftypes_model === 2 ? [3] : this.model.ftypesSelect),
                    'price_model': this.model.price_model,
                    'ocpc_bid_min': this.model.ocpc_bid_min,
                    'ocpc_bid_max': this.model.ocpc_bid_max,
                    'ocpc': ocpc,
                    'urlType': 1, //落地页类型	: 1-普通落地页
                    'url': adv.url, //落地页
                    'audience': this.apt_feed_data,
                }

                //组装创意数据
                postData['data'][advId]['creativeFeed'] = {
                    'creativeFeedName': this.model.creativeFeedName,
                    'ideaType': this.model.ideaType,
                    'titles': this.model.titles,
                    'brand': this.model.brand,
                    'userPortrait': this.model.brand_cover,
                    'monitorUrl': adv.monitorUrl, //检测链接
                }

                postData['data'][advId]['materials'] = adv.materials
            }

            this.postData = postData

            console.log('最终提交的postData：', postData)
        },
        storeOrUpdate() {
            this.loading = true
            let json = Object.assign({}, this.postData)
            storeOrUpdateAdTask(json).then(() => {
                this.current++
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        doTask(taskId, advIndex) {
            this.loading = true
            const json = {
                id: taskId,
                advertiser_id: this.model.ids[advIndex]
            }
            storeOrUpdateAdTask(json).then(res => {
                this.result.success = this.result.success.concat(res.data.success || [])
                this.result.errors = this.result.errors.concat(res.data.errors || [])
            }).catch(() => { })
        },
        close() {
            this.$emit('success')
            this.$emit('update:showCreateForm', false)
        },
        tabClass(adv) {
            if (!adv.anchor_id || !adv.external_url) {
                return 'tab-danger'
            }
            return ''
        },
        scheduleChange() {
            for (let i = 0; i < 7; i++) {
                let item = this.model.schedule[i] ? this.model.schedule[i] : []
                item.forEach((element) => {
                    let i = element
                    if (element % 2 == 1) {
                        i--
                    } else {
                        i++
                    }
                    if (!item.includes(i)) {
                        item.push(i)
                    }
                });

                item.sort(function (a, b) {
                    return a - b;
                });
            }
        },
        changeDXB() {
            this.changeDXB = this.changeDXB === true ? false : true
            // if (val.length > 0) {
            //     this.showDXB = true
            // } else {
            //     this.showDXB = false
            // }
        },
        changeAtp(id) {
            //百度定向包
            getBdAtpFeeds().then(res => {
                this.atpFeeds = res.data.list || []
            })

            if (id) {
                //改变定向包的内容
                this.apt_feed_data = this.atpFeeds.find(item => item.id === id)
                this.apt_feed_data.source_type = 2 //来源：2-单元
            } else {
                this.apt_feed_data = {}
            }
        },
        changeOcpcTransFeeds(value, option) {
            const advertiser_id = option.data.attrs.advertiser_id
            const ocpcTransFeed = option.data.attrs.ocpcTransFeed
            const transTypes = ocpcTransFeed.transTypes

            this.transTypesForm[value] = transTypes
            this.advs[advertiser_id].transType = null
            this.advs[advertiser_id].monitorUrl = ocpcTransFeed.monitorUrl
            // console.log(advertiser_id, ocpcTransFeed, this.transTypesForm, this.advs)
        },
        changePage(value, option) {
            const advertiser_id = option.data.attrs.advertiser_id
            this.advs[advertiser_id].url = value
        },
        validateNumber(rule, value, callback, minValue) {
            value =  parseFloat(value);
            minValue = !minValue ? 1 : minValue

            if (value === '' || value === null) {
                callback(new Error('请输入数字'));
            } else if (isNaN(value)) {
                callback(new Error('请输入有效的数字'));
            } else if (value < minValue) {
                callback(new Error('最小输入为1'));
            } else {
                callback();
            }
        },
        setTitleGroup(group) {
            this.$set(this.model, 'titles', group.titles)
            this.$nextTick(() => {
                this.$refs.title_group.init()
            })
        },
        changeBrand(value, option) {
            const item = option.data.attrs.item
            this.model.brand_cover = item.bd_url ? item.bd_url : item.cover
        },
        getLoopArray(count) {
            return Array.from({ length: count }, (_, index) => index + 1);
        }

    }
}
